import {inject} from '@angular/core'
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree} from '@angular/router'
import {AuthGuardData, createAuthGuard} from 'keycloak-angular'
import {PUBLIC_ACCESS} from './roles'

const isAccessAllowed = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot, authData: AuthGuardData): Promise<boolean | UrlTree> => {
  const { authenticated, keycloak, grantedRoles } = authData
  const { clientId, tokenParsed } = keycloak

  const requiredRoles = route.data['roles'] ?? getDeepestChild(route)?.data['roles'] ?? []

  const publicAccess = requiredRoles.some((role: string) => role === PUBLIC_ACCESS)

  if (publicAccess) {
    return true
  }

  if (!authenticated) {
    await keycloak.login({
      redirectUri: window.location.origin + state.url
    })
    return false
  }

  // User is logged in but still new and has no roles
  if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
    return true
  }
  const router = inject(Router)

  const availableRoles = grantedRoles.resourceRoles[clientId!]
  if (!availableRoles) {
    return router.parseUrl('/not-authorized?redirect=' + encodeURIComponent(state.url))
  }

  const hasRequiredRole = requiredRoles.some((role: string) => availableRoles.includes(role))
  if (hasRequiredRole) {
    return true
  }

  return router.parseUrl('/not-authorized?redirect=' + encodeURIComponent(state.url))
}

function getDeepestChild(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
  while (route.firstChild) {
    route = route.firstChild
  }
  return route
}

export const canActivateAuthRole: CanActivateFn = createAuthGuard<CanActivateFn>(isAccessAllowed)
